import React from "react";

export interface ClickableBlockProps extends React.HTMLProps<HTMLElement> {
	onClick: () => void;
}

export const ClickableBlock = ({ onClick, ...props }) => (
	<div
		onClick={onClick}
		{...props}
		role="button"
		tabIndex={0}
		onKeyUp={(e) => {
			if (e.code === "Enter" || e.code === "Space" || e.code === "NumpadEnter") {
				onClick();

				return false;
			}
		}}
	/>
);
